import { formatDecimal } from "@globals/format";
import { Afix } from "@client/types";

export const number = (val: string) => parseFloat(val);

export const fix = (val: number, fix: number) => {
  if (isNaN(val)) {
    return undefined;
  }
  const x = Math.round(parseFloat(String(val)) * Math.pow(10, fix)) / Math.pow(10, fix);
  return fix > 0 ? formatDecimal(x, fix) : x;
};

export const unit = (val: number | string, unit: string, afix: Afix = Afix.suffix, delimiter: string = " ") => {
  let string = val + "";

  if (afix === Afix.prefix) {
    string = unit + delimiter + string;
  } else {
    string = string + delimiter + unit;
  }

  return string;
};

/**
 * Dvoustavová hodnota jako `"1"` / `"0"`, nebo `undefined`, když ještě nic nepřišlo.
 *
 * `undefined` je tu podstatné: `parseBoolean` bere cokoli neznámého jako `false`, takže by
 * chybějící hodnota mlčky vypadala jako „vypnuto". Rozlišit „ještě nevím" od „nula" je
 * u zvonku nebo dveří ten podstatnější údaj.
 */
export const boolAsBit = (val: unknown): string | undefined => {
  if (val === undefined || val === null || val === "") return undefined;
  if (typeof val === "boolean") return val ? "1" : "0";
  if (typeof val === "number") return val === 0 ? "0" : "1";
  if (typeof val !== "string") return undefined;
  const s = val.trim().toLowerCase();
  if (s === "true" || s === "1") return "1";
  if (s === "false" || s === "0") return "0";
  return undefined;
};

export const bool = (val: string | boolean, on: string, off: string, invert: boolean = false) => {
  return parseBoolean(val) !== invert ? on : off;
};

export const unundefined = (val: string | number | boolean | undefined | null, def: string) => {
  return val !== undefined && val !== null ? val + "" : def;
};

function parseBoolean(value: number | string | boolean): boolean {
  if (typeof value === "string") {
    // Trim the string to avoid extra spaces affecting the check
    value = value.trim().toLowerCase();

    // Handle strings "true" and "1" as true
    if (value === "true" || value === "1") return true;

    // Handle strings "false" and "0" as false
    if (value === "false" || value === "0") return false;
  }

  // Handle actual boolean or numeric types
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;

  // If none of the above, return false by default (can customize as needed)
  return false;
}
